"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContentInner = exports.StyledContent = exports.StyledTriggerArrowIcon = exports.StyledTrigger = exports.StyledHeader = exports.StyledItem = exports.StyledRoot = void 0;
const RadixAccordion = __importStar(require("@radix-ui/react-accordion"));
const styled_components_1 = __importStar(require("styled-components"));
const Icon_1 = require("../Icon");
exports.StyledRoot = (0, styled_components_1.default)(RadixAccordion.Root) `
    box-shadow: 0 0 0 1px var(--ds-color-silver);
    border-radius: var(--ds-border-radius);
    background-color: var(--ds-color-white);
    font-family: var(--ds-font-family);
`;
exports.StyledItem = (0, styled_components_1.default)(RadixAccordion.Item) `
    &:not(:first-of-type) {
        border-top: 1px solid var(--ds-color-silver);
    }

    // the border-radius style is applied to the Accordion.Trigger element
    // but we only know about first and last items in Accordion.Item
    &:first-of-type {
        --ds-accordion-trigger-border-radius: var(--ds-border-radius)
            var(--ds-border-radius) 0 0;
    }
    &:last-of-type:not(:first-of-type) {
        --ds-accordion-trigger-border-radius: 0 0 var(--ds-border-radius)
            var(--ds-border-radius);
    }
    &:last-of-type:first-of-type {
        --ds-accordion-trigger-border-radius: var(--ds-border-radius);
    }
`;
exports.StyledHeader = (0, styled_components_1.default)(RadixAccordion.Header) ``;
exports.StyledTrigger = (0, styled_components_1.default)(RadixAccordion.Trigger) `
    font-size: 1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
    border: none;
    padding: 0.75rem;
    width: 100%;
    transition: background-color 200ms cubic-bezier(0.87, 0, 0.13, 1);
    text-align: start;
    border-radius: var(--ds-accordion-trigger-border-radius);

    &:hover {
        background-color: color-mix(
            in hsl,
            var(--ds-color-night) 5%,
            transparent
        );
    }

    &:not([disabled]):not([tabindex="-1"]):focus {
        box-shadow: none;
        outline: 2px solid var(--ds-color-blue-100);
        outline-offset: 2px;
    }

    &[data-state="open"] {
        border-end-end-radius: 0;
        border-end-start-radius: 0;
    }
`;
exports.StyledTriggerArrowIcon = (0, styled_components_1.default)(Icon_1.Icon) `
    margin-inline-start: 0.5rem;

    // if parent has data-state="open" then rotate the chevron arrow
    [data-state="open"] > & {
        transform: rotate(180deg);
    }
`;
const slideDown = (0, styled_components_1.keyframes) `
    from {
        height: 0;
    }
    to {
        height: var(--radix-accordion-content-height);
    }
`;
const slideUp = (0, styled_components_1.keyframes) `
    from {
        height: var(--radix-accordion-content-height);
    }
    to {
        height: 0;
    }
`;
exports.StyledContent = (0, styled_components_1.default)(RadixAccordion.Content) `
    overflow: hidden;
    &[data-state="open"] {
        animation: ${slideDown} 200ms cubic-bezier(0.87, 0, 0.13, 1);
    }
    &[data-state="closed"] {
        animation: ${slideUp} 200ms cubic-bezier(0.87, 0, 0.13, 1);
    }
`;
exports.StyledContentInner = styled_components_1.default.div `
    font-family: Roboto, sans-serif;
    padding: 0.5rem 0.75rem 0.75rem;
`;
//# sourceMappingURL=Accordion.styles.js.map